import { render, staticRenderFns } from "./NumberOfRooms.vue?vue&type=template&id=15265558&"
import script from "./NumberOfRooms.vue?vue&type=script&lang=ts&"
export * from "./NumberOfRooms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports